import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import { ThemeContextProvider } from './context/themeContext';
import { DeviceWidthContextProvider } from './context/deviceWidthContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <ThemeContextProvider>
      <DeviceWidthContextProvider>
       <App />
      </DeviceWidthContextProvider>
   </ThemeContextProvider>

);

